import React, { useEffect } from 'react';
import { defineMessages } from 'react-intl';
import { useParams } from 'react-router-dom';
import apiConfig from '@constants/apiConfig';
import { commonStatus, statusOptions } from '@constants/masterData';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { showErrorMessage, showSucsessMessage } from '@services/notifyService';
import { Checkbox, Col, Form, Row } from 'antd';

const message = defineMessages({
    error: '{title} failed',
    success: '{title} successfully',
    permissions: 'Permissions',
    employeeNfcPwd: 'NFC Password',
    employeeRfid: 'RFID',
});

const EmployeeForm = ({ form, detail, onCancel, mixinFuncs, executeSave, isEditing, onSave }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(statusOptions, ['label']);
    const params = useParams();
    useEffect(() => {
        if (detail) {
            const permissions = detail.employeePermissions ? preparePermissionArr(detail.employeePermissions) : [];
            form.setFieldsValue({
                ...detail,
                employeePermissions: permissions,
            });
        }
    }, [ detail, form ]);

    const preparePermissionJson = (data) => {
        let permissions = [];
        for (let i = 1; i <= 4; i++) {
            permissions.push(data.includes(i) ? 1 : 0);
        }
        return JSON.stringify(permissions);
    };

    const preparePermissionArr = (data) => {
        const result = [];
        const permissions = JSON.parse(data || '[]');
        if (permissions && permissions.length > 0) {
            for (let i = 0; i < 4; i++) {
                if (permissions[i]) {
                    result.push(i + 1);
                }
            }
        }
        return result;
    };

    const handleSubmit = (values) => {
        const preparedData = {
            employeeId: detail?.id || 0,
            employeeName: values.employeeName,
            employeeNfcPwd: values.employeeNfcPwd || '',
            employeePermissions: preparePermissionJson(values.employeePermissions || []),
            employeePwd: values.employeePwd,
            employeeRfid: values.employeeRfid || '',
            status: isEditing ? values.status : 1,
        };

        const operationMessage = isEditing ? commonMessage.updateEmployees : commonMessage.createEmployees;
        onSave(preparedData);
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
                <Col span={12}>
                    <TextField name="employeeName" label={translate.formatMessage(commonMessage.name)} required />
                </Col>

                <Col span={12}>
                    <TextField name="employeePwd" label={translate.formatMessage(commonMessage.password)} required />
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="employeePermissions"
                        label={translate.formatMessage(message.permissions)}
                        rules={[ { required: true, message: translate.formatMessage(commonMessage.pleaseSelectPermission) } ]}
                    >
                        <Checkbox.Group>
                            <Row gutter={[ 16, 8 ]}>
                                <Col span={12}>
                                    <Checkbox value={1}>{translate.formatMessage(commonMessage.permission1)}</Checkbox>
                                </Col>
                                <Col span={12}>
                                    <Checkbox value={2}>{translate.formatMessage(commonMessage.permission2)}</Checkbox>
                                </Col>
                                <Col span={12}>
                                    <Checkbox value={3}>{translate.formatMessage(commonMessage.permission3)}</Checkbox>
                                </Col>
                                <Col span={12}>
                                    <Checkbox value={4}>{translate.formatMessage(commonMessage.permission4)}</Checkbox>
                                </Col>
                            </Row>
                        </Checkbox.Group>
                    </Form.Item>
                </Col>

                {isEditing && (
                    <Col span={12}>
                        <SelectField
                            label={translate.formatMessage(commonMessage.status)}
                            name="status"
                            required
                            options={statusValues}
                        />
                    </Col>
                )}
            </Row>
        </Form>
    );
};

export default EmployeeForm;
